import React from 'react';
import ShippingMethodsTable from '../components/ShippingMethodsTable';

export function ShippingMethods() {
  return <ShippingMethodsTable />;
}
